import React from "react";
import "./Services.css";
import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>
          <ul className="service__list">
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>
                Illustrating design ideas using storyboards, process flows and
                sitemaps
              </p>
            </li>
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>
                Designing graphic user interface elements, like menus, tabs and
                widgets
              </p>
            </li>
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>
                Develop UI mockups and prototypes that clearly illustrate how
                sites function and look like
              </p>
            </li>
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>
                Prepare and present rough drafts to internal teams and key
                stakeholders
              </p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>
          <ul className="service__list">
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>Designing engaging and responsive landing pages</p>
            </li>
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>
                Integrating client CMS programs and data feeds into websites
              </p>
            </li>
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>Optimising sites for maximum speed and scalability</p>
            </li>
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>
                Providing internal support and external customer service
                throughout the build and launch process of the website
              </p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Backend Development</h3>
          </div>
          <ul className="service__list">
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>Write clean code to develop functional web applications.</p>
            </li>
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>Troubleshoot and debug applications.</p>
            </li>
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>Perform UI tests to optimize performance.</p>
            </li>
            <li>
              <div>
                <BiCheck className="service__list-icon" />
              </div>
              <p>
                Manage cutting-edge technologies to improve legacy applications.
              </p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  );
};

export default Services;
